import React, { useState } from 'react';
import { Accordion, Badge } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa6';
import { FaCircleExclamation } from 'react-icons/fa6';
import { FAQ } from '../../types/tutorials.types';
import './FAQList.scss';

interface FAQListProps {
  faqs: FAQ[];
}

const FAQList: React.FC<FAQListProps> = ({ faqs }) => {
  const [activeKey, setActiveKey] = useState<string | null>(null);

  if (faqs.length === 0) {
    return (
      <div className="no-faqs">
        <p>No se encontraron preguntas frecuentes que coincidan con tu búsqueda.</p>
      </div>
    );
  }

  return (
    <div className="faq-list">
      <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key as string)}>
        {faqs.map((faq) => (
          <Accordion.Item key={faq.id} eventKey={faq.id} className="faq-item">
            <Accordion.Header className="faq-header">
              <div className="faq-question">
                {faq.isImportant && (
                  <FaCircleExclamation className="important-icon" title="Importante" />
                )}
                {faq.question}
                {faq.isNew && (
                  <Badge bg="danger" className="new-badge-faq">
                    NUEVO
                  </Badge>
                )}
              </div>
              <FaChevronDown
                className={`chevron-icon ${activeKey === faq.id ? 'rotated' : ''}`}
              />
            </Accordion.Header>
            <Accordion.Body>
              <div className="faq-answer">
                {faq.answer.split('\n').map((paragraph: string, index: number) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              {faq.lastUpdated && (
                <div className="faq-meta">
                  <small className="text-muted">
                    Última actualización:{' '}
                    {new Date(faq.lastUpdated).toLocaleDateString('es-MX', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </small>
                </div>
              )}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQList;
